<template>
  <main>
    <section class="wrap">
      <div class="bg">
        <img src="@/assets/img/login/building.png" width="100%" />
        <div class="wrap-box inter-box">
          <div class="login-box">
            <div class="login-txt">
              <el-tabs value="phone" class="tab">
                <el-tab-pane label="验证码登录" name="phone"></el-tab-pane>
              </el-tabs>
            </div>
            <Logincomp
              ref="loginComp"
              v-if="company_id && order_id"
              :company_id="company_id"
              :order_id="order_id"
            />
          </div>
        </div>
      </div>
      <div class="bg-right">
        <img src="@/assets/img/login/rightperson.png" />
      </div>
    </section>
  </main>
</template>

<script>
import Logincomp from '@components/loginByPhone/index.vue'
export default {
  components: { Logincomp },
  data() {
    return {
      win: window,
      order_id: '',
      company_id: '',
    }
  },
  async mounted() {
    const { company_id, order_id } = this.$route.query;
    if (!order_id) {
      this.$message({
        type: 'error',
        message: '没有获取到订单号',
      });
      return;
    }
    if (!company_id) {
      this.$message({
        type: 'error',
        message: '没有获取到公司ID',
      });
    }
    this.company_id = company_id;
    this.order_id = order_id;
    // this.setRem(1920)
  },
  // methods: {
  //   setRem(designWidth) {
  //     setRem(designWidth)
  //     // 改变窗口大小时重新设置 rem
  //     window.onresize = function() {
  //       setRem(designWidth)
  //     }
  //   }
  // }
}
</script>

<style lang="scss">
@import "@/assets/css/no-change.scss";
* {
  margin: 0;
  padding: 0;
}
.reserved {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1.6rem;
  /* prettier-ignore */
  font-size: 0.6rem;
  text-align: center;
  color: #9e9e9e;
}
.wrap {
  position: relative;
  min-height: 100vh;
  .bg {
    position: relative;
    top: 0;
    height: 75%;
    /* prettier-ignore */
    min-height: 25rem;
    background: rgba(55, 101, 236, 1);
    img {
      height: 100%;
    }
  }
  .bg-right {
    position: absolute;
    width: 30%;
    right: 15%;
    bottom: 8%;
    img {
      width: 100%;
    }
  }
  .wrap-box {
    position: absolute;
    display: inline-block;
    width: 30%;
    /* prettier-ignore */
    // min-width: 16.7501rem;
    /* prettier-ignore */
    // max-width: 22.5rem;
    /* prettier-ignore */
    min-width: 335Px;
    /* prettier-ignore */
    max-width: 450Px;
    padding: 0 2.3rem 2.5rem 2.3rem;
    /* prettier-ignore */
    bottom: 4rem;
    left: 11rem;
    background: #fff;
    z-index: 999;
    .login-btn {
      background: #3665ec;
    }
    .change-txt {
      width: 30%;
      /* prettier-ignore */
      max-width: 4.5rem;
      user-select: none;
    }
  }
}

@media screen and (max-width: 710px) {
  .bg-right {
    display: none;
  }
  .wrap-box {
    left: 50% !important;
    transform: translateX(-50%);
  }
}
.login-box {
  img.password-close-icon {
    /* prettier-ignore */
    width: 1rem ;
    vertical-align: middle;
    height: auto !important;
    line-height: 100%;
    cursor: pointer;
    margin-top: 50%;
    transform: translateY(-20%);
  }
  li {
    list-style: none;
  }
  .login-txt {
    height: 5rem;
    /* prettier-ignore */
    max-height: 5rem;
    line-height: 5rem;
    margin-top: 1.2501rem;
    font-size: 2rem;
    color: #4281f7;
    .tab {
      float: left;
    }
  }
  .verify-box {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    line-height: 3rem;
    #verify-img-box {
      flex: 1;
      cursor: pointer;
      display: inline-block;
      width: 70%;
      svg {
        width: 100% !important;
      }
    }
    .verify-img {
      position: relative;
      max-width: 7.5rem;
      height: 5.5rem;
      /* prettier-ignore */
      min-width: 4.2501rem ;
      /* prettier-ignore */
      /* margin-right: 0.2501rem; */
      top: -6px;
      vertical-align: middle;
      font-size: 0;
    }
    .change-txt {
      display: inline-block;
      /*  width: 5.5rem; */
      /* prettier-ignore */
      /*  max-width: 2.2501rem; */
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-right: 0.1rem; /*no*/
      /* prettier-ignore */
      font-size: 0.7rem;
      /* prettier-ignore */
      height: 100%;
      /* prettier-ignore */
      padding-left: 0.2501rem;
      color: #4281f7;
      cursor: pointer;
      user-select: none;
    }
  }
  .login-btn,
  .login-btn:hover {
    background: #3665ec;
    color: #fff;
    width: 100%;
    border: 0 !important;
  }
  .jump-register {
    color: #4281f7;
    text-decoration: none;
    display: inline-block;
    /* prettier-ignore */
    margin-top: 0.3rem;
    margin-left: 0.1501rem;
  }
  .language-list {
    display: inline-block;
    float: right;
    .lng-txt {
      /* prettier-ignore */
      font-size: 0.7rem;
    }
  }
}
</style>
